import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class SiteContact extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/site/contact'
    super(store, path)
  }
}
